import type { PortalContextResponse } from '@lipaflow/portal-core'

/**
 * Rental-flavoured defaults: renters see rental labels while
 * `/portal/context` is loading or unavailable. Moved out of
 * `packages/portal-core` by ADR-0004.
 */
export const RENTAL_DEFAULT_CONTEXT: PortalContextResponse = {
  tenant_name: '',
  vertical_code: 'rental',
  labels: {
    payer: 'Tenant',
    entity: 'Unit',
    obligation: 'Invoice',
    period: 'Month',
    entity_reference: 'Unit Number',
  },
  features: {},
}
